@for (transport of transports; track transport) {
  <app-action-item borderColor="#dedede" titleColor="#000000" [iconCSS]="actionItem?.iconCSS" backgroundColor="var(--shade-2-color)" color="#000000"
    titleDictionaryKey="dd.appc_cfg_action_item.{{actionItem.id}}.name"
    (click)="handleClick(transport)" matRipple class="action-item">
    <sc-padding fitHeight>
      <sc-scroll-pane>
        <app-transport-details [mode]="TransportDetailMode.READONLY" [layout]="layoutDefinition" [transport]="transport">
        </app-transport-details>
      </sc-scroll-pane>
    </sc-padding>
  </app-action-item>
}
